import { atom, atomFamily } from "recoil";
import * as models from "./models";
import { recoilPersist } from "recoil-persist";
import { AppointmentsModel } from "views/Schedule";

const { persistAtom } = recoilPersist({
  key: "shop",
  storage: sessionStorage,
});

export const overlayState = atom({
  key: "overlayState",
  default: false,
});

export const addressFormState = atom({
  key: "addressFormState",
  default: {
    streetNumber: "",
    streetName: "",
    apartmentNumber: "",
    city: "",
    stateProv: "",
    zipCode: "",
    locationId: 0,
  } as models.AddressSearchModel,
});

export const toastState = atom({
  key: "toastState",
  default: {
    show: false,
    variant: "",
    header: "",
    message: "",
  } as models.ToastModel,
});

export const locationIdState = atom({
  key: "locationIdState",
  default: 0,
});

export const residentialStructureState = atom({
  key: "residentialStructureState",
  default: false,
});

export const cartState = atom({
  key: "cartState",
  default: {} as models.CartModel,
});

export const browseBannerState = atom({
  key: "browseBannerState",
  default: {} as models.BrowseBannerModel,
});

export const browseBannerMessageState = atom({
  key: "browseBannerMessageState",
  default: "",
});

export const mobileRegistryModalState = atom({
  key: "mobileRegistryModalState",
  default: false,
});

export const scheduleState = atom({
  key: "scheduleState",
  default: {
    optionSelected: null,
    securitySchedule: {
      workDate: null,
      workTime: null,
      workTimeFriendly: null,
      asap: false,
      availableAppointments: [],
    },
    nonSecuritySchedule: { workDate: null, workTime: null, workTimeFriendly: null, asap: false },
    installationTextNumber: "",
    shippingAddress: { streetNumber: null, streetName: null, apartmentNumber: null, city: null, state: null, zipCode: null },
    billCycle: 2,
  } as models.ScheduleModel,
  effects_UNSTABLE: [persistAtom],
});

export const showPremiumWifiModalState = atom({
  key: "showPremiumWifiModalState",
  default: false,
});

export const appointmentsState = atom({
  key: "appointmentsState",
  default: {} as AppointmentsModel,
});

export const agreedWithTcState = atom({
  key: "customerAgreedWithTermsState",
  default: false,
});

export const agreeWithCustomerTermsState = atom({
  key: "agreeWithCustomerTermsState",
  default: false,
});

export const isExistingCustomerState = atom({
  key: "isExistingCustomerState",
  default: false,
});

export const broadbandLabelAccordionOpenState = atomFamily({
  key: "broadbandLabelAccordionOpenState",
  default: false,
});

export const showChangeBillingAddressModalState = atom({
  key: "showChangeBillingAddressModalState",
  default: false,
});

export const selectedAddressTypeState = atom({
  key: "selectedAddressTypeState",
  default: "",
});

export const showAdvertisingModalState = atom({
  key: "showAdvertisingModalState",
  default: false,
});

export const advertisingModalDataState = atom({
  key: "advertisingModalDataState",
  default: {} as models.AdvertisingModalModel,
});

export const adActionsState = atom({
  key: "adActionsState",
  default: [] as models.AdActionsArrayModel,
});

export const customerInfoCaptureModalState = atom({
  key: "customerInfoCaptureModalState",
  default: false,
});

export const termsAndConditionsAgreementAcceptedState = atom({
  key: "termsAndConditionsAgreementAcceptedState",
  default: "" as any,
});

export const customerServiceAgreementAcceptedState = atom({
  key: "customerServiceAgreementAcceptedState",
  default: "" as any,
});
